import { useQuery } from '@tanstack/react-query';
import {
  getUrlTypesStatsForDomain,
  UrlTypesStatsResponse,
} from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';
import { ChatType } from '../../../../../types/monitor/ChatType';

const GET_URL_TYPES_STATS_FOR_DOMAIN = 'get-url-types-stats-for-domain';

export const useGetUrlTypesStatsForDomain = (
  projectId: number | null,
  domain: string,
  chatType: ChatType | null,
  from: Date | null,
  to: Date | null,
  monitorPromptIds?: number[],
  filterMonitorTypes?: string[]
) => {
  const queryEnabled = !!projectId && !!domain && !!chatType && !!from && !!to;

  const fromTimestamp = from?.getTime() ?? null;
  const toTimestamp = to?.getTime() ?? null;

  const {
    data: urlTypesStats,
    isLoading,
    isError,
    error,
  } = useQuery<UrlTypesStatsResponse[]>({
    queryKey: [GET_URL_TYPES_STATS_FOR_DOMAIN, projectId, domain, chatType, fromTimestamp, toTimestamp, monitorPromptIds, filterMonitorTypes],
    queryFn: () => getUrlTypesStatsForDomain(projectId!, domain, chatType!, from, to, monitorPromptIds, filterMonitorTypes),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    urlTypesStats: queryEnabled ? urlTypesStats : undefined,
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
  };
};
